import axios from 'axios'
import store from '../store'
import router from '../router'

// 创建axios实例
const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'https://api.zhongkepeili.cn/api',
  timeout: 5000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 在请求发送前做一些处理
    console.log('发送请求:', {
      method: config.method,
      url: config.url,
      baseURL: config.baseURL,
      fullURL: config.baseURL + config.url,
      params: config.params,
      data: config.data
    })
    
    const token = store.state.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    // 对响应数据做处理
    console.log('收到响应:', {
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
      config: {
        method: response.config.method,
        url: response.config.url,
        baseURL: response.config.baseURL,
        fullURL: response.config.baseURL + response.config.url
      },
      data: response.data
    })
    
    const res = response.data
    
    // 如果响应包含code字段，根据code判断是否成功
    if (res.code !== undefined && res.code !== 200 && res.code !== 201) {
      // 处理错误
      if (res.code === 401) {
        // 未授权，跳转到登录页
        store.commit('clearToken')
        router.push('/login')
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    
    return res
  },
  error => {
    // 对响应错误做处理
    console.error('响应错误:', {
      message: error.message,
      config: error.config ? {
        method: error.config.method,
        url: error.config.url,
        baseURL: error.config.baseURL,
        fullURL: error.config.baseURL + error.config.url
      } : null,
      response: error.response ? {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data
      } : null
    })
    
    if (error.response) {
      switch (error.response.status) {
        case 401:
          store.commit('clearToken')
          router.push('/login')
          break
        case 403:
          console.error('没有权限访问')
          break
        case 404:
          console.error('请求的资源不存在')
          break
        case 500:
          console.error('服务器内部错误')
          break
      }
    }
    return Promise.reject(error)
  }
)

export default request